import { Flex, Spacing, Text } from '@billy/design-system'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { AUTOMATIC_PAYMENT_REMINDERS_MAX_DAYS } from '../../../../../../constants/automaticPaymentRemindersMaxDays'
import { AUTOMATIC_PAYMENT_REMINDERS_MIN_DAYS } from '../../../../../../constants/automaticPaymentRemindersMinDays'
import { useAutomaticPaymentRemindersModalForm } from '../../../../../../contexts/automaticPaymentRemindersModalFormContext'
import { AutomaticPaymentRemindersType } from '../../../../../../enums/automaticPaymentRemindersType'
import { AutomaticPaymentRemindersDaysSelect } from '../../../../../AutomaticPaymentRemindersDaysSelect'
import { AutomaticPaymentRemindersRepeatTypeSelect } from '../../../../../AutomaticPaymentRemindersRepeatTypeSelect'

export const AutomaticPaymentRemindersDaysFields = (): ReactElement => {
  const { t } = useTranslation()
  const { variant } = useAutomaticPaymentRemindersModalForm()

  const isAfterDueDate = variant === AutomaticPaymentRemindersType.AfterDueDate
  const description = isAfterDueDate
    ? t('settings.organization.external_invoice.automatic_payment_reminders.modal.form.after_due_date.description')
    : t('settings.organization.external_invoice.automatic_payment_reminders.modal.form.before_due_date.description', {
        max: AUTOMATIC_PAYMENT_REMINDERS_MAX_DAYS,
        min: AUTOMATIC_PAYMENT_REMINDERS_MIN_DAYS,
      })

  return (
    <Flex flexDirection="column" gap={Spacing.S8}>
      <Text weight="bold">
        {t('settings.organization.external_invoice.automatic_payment_reminders.modal.description')}
      </Text>
      <Flex alignItems="center" gap={Spacing.S8}>
        {isAfterDueDate && <AutomaticPaymentRemindersRepeatTypeSelect />}
        <AutomaticPaymentRemindersDaysSelect />
        <Text colorVariant="label" variant="bodySM">
          {description}
        </Text>
      </Flex>
    </Flex>
  )
}
